import {authMiddleware} from "./loginAction";
import cfg, {
  handleResponse,
  handlePrepareData
} from "../constants";

export const getcourseDataAction = (filter, isAdmin = false, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/getcourse-data', {
    method: "POST",
    body: JSON.stringify(filter),
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

export const getcourseDataDeleteAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/getcourse-data-item/' + id, {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const getcourseDataEditAction = (item) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/getcourse-data-item', {
    method: "POST",
    headers,
    body: JSON.stringify(item)
  }).then(handleResponse).then(handlePrepareData);
};

export const getcourseDataGetAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/getcourse-data-item/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      return data.getcourse_data;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};
